import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PackageTypeDetailModel } from 'app/generated/backend/trade/api/package-type-detail-model';

@Injectable()
export class PackageTypeDetailHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		id: number
	): Observable<JsonResourceResponse<PackageTypeDetailModel>> {
		return this.http.get<JsonResourceResponse<PackageTypeDetailModel>>(`api/v1/trade/packageTypes/detail/${id}`).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	put(
		id: number,
		request: PackageTypeDetailModel
	): Observable<JsonResourceResponse<PackageTypeDetailModel>> {
		return this.http.put<JsonResourceResponse<PackageTypeDetailModel>>(`api/v1/trade/packageTypes/detail/${id}`, request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	delete(
		id: number
	): Observable<void> {
		return this.http.delete<void>(`api/v1/trade/packageTypes/detail/${id}`).pipe(
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		PackageTypeDetailHandlerService
	]
})
export class PackageTypeDetailHandlerModule { }
